<template>
  <div class="card">
    <DataView
      :value="products"
      layout="grid"
      :paginator="true"
      :rows="9"
      :sortOrder="sortOrder"
      :sortField="sortField"
    >
      <template #header>
        <div class="grid grid-nogutter">
          <div class="col-6" style="text-align: left">
            <Dropdown
              v-model="sortKey"
              :options="sortOptions"
              optionLabel="label"
              :placeholder="$t('ecom.sort_by_price')"
              @change="onSortChange($event)"
            />
          </div>
          <div class="col-6" style="text-align: right">
            <!-- <DataViewLayoutOptions v-model="layout" /> -->
          </div>
        </div>
      </template>

      <template #grid="slotProps">
        <div class="col-12 md:col-4">
          <!-- <pre>{{ slotProps }}</pre>-->

          <div class="product-grid-item card">
            <!--
            <div class="product-grid-item-top">
    
                <div>
                    <i class="pi pi-tag product-category-icon"></i>
                    <span class="product-category"></span>
                </div>
    
                <span>2</span>
    
            </div>
            -->
            <div class="product-grid-item-content">
              <img
                class="thumbnail"
                :src="!!slotProps.data.thumbnail?slotProps.data.thumbnail:'/assets/img/no-image.jpg'"
                :alt="$t(slotProps.data.title)"
              />
              <div class="product-name-container">
                <div class="product-name">
                  {{ $t(slotProps.data.title) }}
                </div>
              </div>
              <div class="product-description">
                {{ $t(slotProps.data.description) }}
              </div>
            </div>
            <div class="product-grid-item-bottom">
              <span class="product-price"
                >€ {{ slotProps.data.variants[0].prices[0].amount / 100 }}</span
              >
              <Button
                @click="purchase(slotProps.data)"
                icon="pi pi-shopping-cart"
              ></Button>
            </div>
          </div>
        </div>
      </template>
    </DataView>
    <Dialog
      :header="purchaseHeader"
      :modal="true"
      v-model:visible="purchaseDialog"
      @hide="hideModal"
    >
      <iframe
        frameborder="0"
        width="600"
        height="900"
        :src="
          'https://red-island-0c554ae03.2.azurestaticapps.net/' +
            dialogItem.handle +
            '?language=' +
            locale +
            '&email=' +
            email
        "
        v-if="dialogItem != null"
      ></iframe>
    </Dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      purchaseDialog: false,
      purchaseHeader: "",
      layout: "list",
      sortKey: null,
      sortOrder: null,
      sortField: null,
      sortOptions: [
        { label: this.$t("ecom.lowest_price"), value: "price" },
        { label: this.$t("ecom.higest_price"), value: "!price" },
      ],
      dialogItem: null,
    };
  },
  computed: {
    products() {
      return this.$store.getters["products/products"].map((product) => {
        return {
          ...product,
          price: product.variants[0].prices[0].amount / 100,
        };
      });
    },
    locale: function() {
      return this.$store.getters["preferences/locale"];
    },
    email: function() {
      return this.$store.getters["profile/email"];
    },
  },
  created() {
    this.$store.dispatch("products/getProducts");
  },
  methods: {
    hideModal() {
      this.dialogItem = null;
    },
    purchase(product) {
      this.dialogItem = product;
      this.purchaseDialog = true;
      this.purchaseHeader =
        this.$t("ecom.purchase") + " " + this.$t(product.title);
    },
    onSortChange(event) {
      const value = event.value.value;
      const sortValue = event.value;

      if (value.indexOf("!") === 0) {
        this.sortOrder = -1;
        this.sortField = value.substring(1, value.length);
        this.sortKey = sortValue;
      } else {
        this.sortOrder = 1;
        this.sortField = value;
        this.sortKey = sortValue;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.thumbnail {
  max-width: 200px;
  max-height: 200px;
}

.card {
  background: #ffffff;
  padding: 2rem;
  box-shadow: 0 2px 1px -1px rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.14),
    0 1px 3px 0 rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  margin-bottom: 2rem;
}

.p-dropdown {
  width: 14rem;
  font-weight: normal;
}

.product-name-container {
  height: 50px;
}
.product-name {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;

  font-size: 1.5rem;
  font-weight: 700;
}

.product-description {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  margin: 0 0 1rem 0;
}

.product-category-icon {
  vertical-align: middle;
  margin-right: 0.5rem;
}

.product-category {
  font-weight: 600;
  vertical-align: middle;
}

::v-deep(.product-list-item) {
  display: flex;
  align-items: center;
  padding: 1rem;
  width: 100%;
  img {
    width: 50px;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
    margin-right: 2rem;
  }
  .product-list-detail {
    flex: 1 1 0;
  }
  .p-rating {
    margin: 0 0 0.5rem 0;
  }
  .product-price {
    font-size: 1.5rem;
    font-weight: 600;
    margin-bottom: 0.5rem;
    align-self: flex-end;
  }
  .product-list-action {
    display: flex;
    align-items: center;
    padding: 1rem;
    width: 100%;
    img {
      width: 50px;

      margin-right: 2rem;
    }
    .product-list-detail {
      flex: 1 1 0;
    }
    .p-rating {
      margin: 0 0 0.5rem 0;
    }
    .product-price {
      font-size: 1.5rem;
      font-weight: 600;
      margin-bottom: 0.5rem;
      align-self: flex-end;
    }
    .product-list-action {
      display: flex;
      flex-direction: column;
    }
    .p-button {
      margin-bottom: 0.5rem;
    }
  }
}

.product-grid-item {
  margin: 0.5rem;
  border: 1px solid var(--surface-border);
  .product-grid-item-top,
  .product-grid-item-bottom {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  img {
    margin: 2rem 0;
  }
  .product-grid-item-content {
    text-align: center;
  }
  .product-price {
    font-size: 1.5rem;
    font-weight: 600;
  }
}

@media screen and (max-width: 576px) {
  .product-list-item {
    flex-direction: column;
    align-items: center;
    img {
      margin: 2rem 0;
    }
    .product-list-detail {
      text-align: center;
    }
    .product-price {
      align-self: center;
    }
    .product-list-action {
      display: flex;
      flex-direction: column;
    }
    .product-list-action {
      margin-top: 2rem;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      width: 100%;
    }
  }
}
</style>
